import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import Modal from '../Modal'
import Dropdown1 from '../Dropdown1'
import { useSelector, useDispatch } from 'react-redux'
import { commonActions } from 'srcReact/components/actions'
import { useTranslation } from 'react-i18next'
import Button from '../Button'
import TooltipWrapper from '../TooltipWrapper'
import { isMobileScreen, urlSearchParams } from 'srcReact/helpers/utils'

function Timezone({ handleSelectTimezone, isVirtual, currentTimezone }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedTimezone, setselectedTimezone] = useState(null)
  const {
    common: {
      userLocation,
      isNative,
      timezone: { list, value: timezoneValue }
    }
  } = useSelector((state) => state)
  useEffect(() => {
    if (!currentTimezone) {
      if (userLocation) {
        if (isNative) {
          const lat = urlSearchParams('lat')
          const long = urlSearchParams('lon')
          if (lat && long) {
            dispatch(commonActions.getTimezoneByLatLong(lat, long))
          }
        } else {
          dispatch(commonActions.getTimezoneByLatLong(userLocation.latitude, userLocation.longitude))
        }
      }
    }
  }, [])

  useEffect(() => {
    if (currentTimezone) {
      if (currentTimezone.timeZoneId || currentTimezone.timezone_id) {
        setselectedTimezone({
          id: currentTimezone.timezone_id || currentTimezone.id,
          name: currentTimezone.timeZoneName || currentTimezone.name,
          abbreviation: currentTimezone.timeZoneAbbreviation || currentTimezone.abbreviation,
          utc_offset: currentTimezone.UTCOffset || currentTimezone.utc_offset
        })
      } else {
        setselectedTimezone(currentTimezone)
      }
    }
  }, [currentTimezone])

  const openModal = () => {
    setIsModalOpen(true)
    if (list?.length === 0) {
      dispatch(commonActions.getTimezones())
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }
  const handleTimezoneChange = () => {
    handleSelectTimezone(selectedTimezone)
    closeModal()
  }

  return (
    <div className={styles.timezoneWrapper}>
      <TooltipWrapper
        className='timezoneTooltip'
        position={isMobileScreen() ? 'left top' : 'top center'}
        triggerElement={
          <button
            type='button'
            className={`${styles.timezone} ${isVirtual && styles.clickableTimezone}`}
            onClick={isVirtual && openModal}>
            {currentTimezone?.abbreviation || currentTimezone?.timeZoneAbbreviation}
          </button>
        }
        content={currentTimezone?.name || currentTimezone?.timeZoneName}
      />

      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          handleClose={closeModal}
          title={t('event.create.timing.selectTimezone')}
          className='timezone-modal'>
          <Dropdown1
            className={styles.dropdown}
            options={list}
            placeholder={t('global.select')}
            value={selectedTimezone}
            isSearchable={true}
            onChange={(e) => {
              setselectedTimezone(e)
            }}
          />
          <div className={styles.buttons}>
            <Button style='secondary' size='large' text={t('global.cancel')} handleClick={closeModal} />
            <Button text={t('global.confirm')} size='large' handleClick={handleTimezoneChange} />
          </div>
        </Modal>
      )}
    </div>
  )
}

export default Timezone
